import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
    apiKey: "AIzaSyCurY8FK-gqPulAnQ2-0X3cgxvb-fAw4Lg",
    authDomain: "nimalmaulafoundation-web.firebaseapp.com",
    projectId: "nimalmaulafoundation-web",
    storageBucket: "nimalmaulafoundation-web.firebasestorage.app",
    messagingSenderId: "1033385167866",
    appId: "1:1033385167866:web:8277c61061ca21008d7243"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export default app;